<template>
  <div
    class="bg-card rounded-[16px] p-6 border border-border relative overflow-hidden h-full"
  >
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-[14px] font-semibold text-foreground">Jobs</h2>
      <router-link
        to="/jobs"
        class="text-[12px] text-muted-foreground hover:text-foreground underline"
      >
        See more
      </router-link>
    </div>

    <div class="space-y-2">
      <!-- Loading State -->
      <template v-if="loading">
        <div v-for="i in 5" :key="i" class="p-3 border border-border rounded-[10px] space-y-2">
          <div class="flex items-start gap-3">
            <SkeletonLoader width="48px" height="48px" borderRadius="10px" />
            <div class="flex-1 space-y-2">
              <SkeletonLoader width="60px" height="12px" />
              <SkeletonLoader width="120px" height="16px" />
            </div>
          </div>
        </div>
      </template>

      <!-- Content State -->
      <template v-else-if="jobs && jobs.length > 0">
        <div
          v-for="job in jobs"
          :key="job.id"
          @click="$router.push(`/jobs/${job.id}`)"
          class="flex items-start justify-between p-3 hover:bg-muted/50 rounded-[10px] transition-colors cursor-pointer border border-border"
        >
          <div class="flex items-start gap-3">
            <div
              class="w-12 h-12 bg-primary rounded-[10px] flex-shrink-0 flex items-center justify-center"
            >
              <slot name="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="3" class="fill-primary-foreground" />
                  <circle
                    cx="12"
                    cy="6"
                    r="1.5"
                    class="fill-primary-foreground"
                  />
                  <circle
                    cx="12"
                    cy="18"
                    r="1.5"
                    class="fill-primary-foreground"
                  />
                </svg>
              </slot>
            </div>
            <div>
              <p class="text-[11px] text-muted-foreground mb-0.5">
                {{ job.company }}
              </p>
              <h3 class="text-[14px] font-semibold text-foreground">
                {{ job.position }}
              </h3>
            </div>
          </div>

          <div class="text-right flex-shrink-0">
            <p class="text-[11px] text-muted-foreground">{{ job.postedTime }}</p>
            <p
              class="text-[11px] text-foreground font-medium mt-1 flex items-center gap-1 justify-end"
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_22326_53408)">
                  <mask
                    id="mask0_22326_53408"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="10"
                    height="10"
                  >
                    <path d="M10 0H0V10H10V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_22326_53408)">
                    <path
                      d="M8.59244 3.52116C8.15494 1.59616 6.47577 0.729492 5.00077 0.729492C5.00077 0.729492 5.00077 0.729492 4.99661 0.729492C3.52577 0.729492 1.84244 1.59199 1.40494 3.51699C0.917439 5.66699 2.23411 7.48783 3.42577 8.63366C3.86744 9.05866 4.43411 9.27116 5.00077 9.27116C5.56744 9.27116 6.13411 9.05866 6.57161 8.63366C7.76327 7.48783 9.07994 5.67116 8.59244 3.52116ZM5.00077 5.60866C4.27577 5.60866 3.68827 5.02116 3.68827 4.29616C3.68827 3.57116 4.27577 2.98366 5.00077 2.98366C5.72577 2.98366 6.31327 3.57116 6.31327 4.29616C6.31327 5.02116 5.72577 5.60866 5.00077 5.60866Z"
                      fill="#292D32"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_22326_53408">
                    <rect width="10" height="10" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              {{ job.location }}
            </p>
          </div>
        </div>
      </template>

      <!-- Empty State -->
      <div v-else class="text-center py-10 text-muted-foreground text-sm">
        No recent jobs found.
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonLoader from "@/components/SkeletonLoader.vue";

export default {
  name: "JobsCard",
  components: {
    SkeletonLoader,
  },
  props: {
    jobs: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    watermark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
